import { RegisteredComponent } from "@builder.io/sdk-react";
import { generalFormConfig } from "./generalFormConfig";
import { textualFormConfig } from "./textualFormConfigs";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const textareaBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Form:TextArea",
  image:
    "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",
  override: true,
  noWrap: true,
  canHaveChildren: false,
  static: true,
  defaultStyles: {
    width: "100%",
    height: "100%",
    minHeight: "1.5rem",
    outline: "none",
    transition: "colors",
    transitionDuration: "300ms",
    transitionTimingFunction: "linear",
  },
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "minLength",
      type: "number",
      localized: false,
      required: false,
    },
    {
      name: "maxLength",
      type: "number",
      localized: false,
      required: false,
    },
    {
      name: "value",
      type: "string",
      required: true,
      localized: false,
    },
    {
      name: "onBlur",
      type: "javascript",
      localized: false,
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onInvalid",
      type: "javascript",
      localized: false,
    },
    ...(generalFormConfig ?? []),
    ...(textualFormConfig ?? []),
    DLT_FIELD,
    DLD_FIELD,
  ],
};
